"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateExports = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const vr = __importStar(require("../../variables"));
/**
 * Simple time-delayed boolean toggle component to facilitate
 * CSS-based animation in the child components. Also provides
 * optional conditional rendering base on toggle status.
 */
const AnimateToggle = _ref => {
  let {
    toggle,
    duration = vr.BASE_TRANSITION,
    unmountWhen,
    render
  } = _ref;
  // ----------------------------------------
  // Methods
  // Invokable check for conditional render
  const calcShouldUnmount = () => unmountWhen === toggle;
  // ----------------------------------------
  // Component state
  // Conditional render boolean
  const [canRender, setCanRender] = (0, react_1.useState)(!calcShouldUnmount());
  // Timeout reference that toggles `canRender` status
  const conditionalRenderDelay = (0, react_1.useRef)(setTimeout(() => undefined));
  // The boolean provided to the child component
  // Note this is purposefully separate from the `toggle` prop,
  // as although their values are technically bound, this value
  // is only toggled in value after `duration` timeout delay
  const [animToggle, setAnimToggle] = (0, react_1.useState)(toggle);
  // ----------------------------------------
  // Effects
  // Sets:
  // - the value of `animToggle` - possibly after a delay, if appropriate
  // - the value of the `canRender` conditional render toggle
  (0, react_1.useEffect)(() => {
    // Determine upcoming conditional render prospects
    const shouldUnmount = calcShouldUnmount();
    const willRender = !canRender && !shouldUnmount;
    const willUnmount = canRender && shouldUnmount;
    // Clear any existing timeouts to prevent any race conditions
    clearTimeout(conditionalRenderDelay.current);
    if (willRender) {
      conditionalRenderDelay.current = setTimeout(() => undefined);
      setCanRender(true);
      // Timeout of 1ms to allow `canRender={true}` to digest and
      // propagate to child render via `animToggle`. This is critical
      // in the event of of conditional rendering and the `animToggle`
      // changing, i.e. a component being conditionally renderered and
      // THEN animating in. Without this, it would render in "already animated".
      setTimeout(() => setAnimToggle(toggle), 1);
    } else if (willUnmount) {
      setAnimToggle(toggle);
      conditionalRenderDelay.current = setTimeout(() => {
        // `calcShouldUnmount` is called again here due to the async
        // nature of `setTimeout, to be certain of the prop state
        setCanRender(!calcShouldUnmount());
      }, duration);
    } else {
      // Else if there is so `unmountWhen` prop, update the `animToggle`
      // immediately so that it can propagate to children, lest it never get set
      setAnimToggle(toggle);
    }
  }, [unmountWhen, toggle]);
  // ----------------------------------------
  // Render
  return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {
    children: canRender && render(animToggle)
  });
};
exports.default = AnimateToggle;
// ----------------------------------------
/**
 * Returns a tuple of pre-configured iterations of the provided
 * animation component. For example, if you provide it a "fade"
 * animation component, it will return a tuple with pre-configured
 * "fade out" and "fade in" components. These ought to be exported
 * as named exports in addition to the default animation export.
 *
 * This is for usage convenience, readability and ease of comprehension.
 */
const generateExports = AnimComponent => {
  // The "out" animation ought to be the default behaviour
  // of the animation component boolean toggle, and thus
  // merely requires a mapping of prop names
  const AnimateOut = _a => {
    var {
        activate: toggle
      } = _a,
      props = __rest(_a, ["activate"]);
    return (0, jsx_runtime_1.jsx)(AnimComponent, Object.assign({
      toggle
    }, props));
  };
  // The "in" animation requires the two core boolean values
  // to be flipped, with a precaution in place to retain any
  // `undefined` values for the optional `unmountWhen` prop.
  const AnimateIn = _a => {
    var {
        activate,
        unmountWhen
      } = _a,
      props = __rest(_a, ["activate", "unmountWhen"]);
    return (0, jsx_runtime_1.jsx)(AnimComponent, Object.assign({
      toggle: !activate,
      unmountWhen: typeof unmountWhen === "boolean" ? !unmountWhen : undefined
    }, props));
  };
  return [AnimateOut, AnimateIn];
};
exports.generateExports = generateExports;